/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicImport } from './routes/_public'
import { Route as FramelessImport } from './routes/_frameless'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as PublicLoginImport } from './routes/_public/login'
import { Route as AuthenticatedDashboardImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedSchedulerRouteImport } from './routes/_authenticated/scheduler/route'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar/route'
import { Route as AuthenticatedLeadsFilterRouteImport } from './routes/_authenticated/leads/$filter/route'
import { Route as AuthenticatedEventsFilterRouteImport } from './routes/_authenticated/events/$filter/route'
import { Route as AuthenticatedCustomersFilterRouteImport } from './routes/_authenticated/customers/$filter/route'
import { Route as AuthenticatedLeadsFilterIndexImport } from './routes/_authenticated/leads/$filter/index'
import { Route as AuthenticatedEventsFilterIndexImport } from './routes/_authenticated/events/$filter/index'
import { Route as AuthenticatedCustomersFilterIndexImport } from './routes/_authenticated/customers/$filter/index'
import { Route as AuthenticatedEventsToolsGapFinderImport } from './routes/_authenticated/events/tools/gap-finder'
import { Route as AuthenticatedEventsToolsEventPacksImport } from './routes/_authenticated/events/tools/event-packs'
import { Route as AuthenticatedEventsEventIdImport } from './routes/_authenticated/events/event/$id'
import { Route as AuthenticatedCustomersCustomerIdImport } from './routes/_authenticated/customers/customer/$id'
import { Route as AuthenticatedLeadsLeadIdReviewImport } from './routes/_authenticated/leads/lead/$id/review'
import { Route as AuthenticatedLeadsLeadIdQuoteImport } from './routes/_authenticated/leads/lead/$id/quote'
import { Route as AuthenticatedLeadsLeadIdPricingImport } from './routes/_authenticated/leads/lead/$id/pricing'
import { Route as AuthenticatedLeadsLeadIdMessagesImport } from './routes/_authenticated/leads/lead/$id/messages'
import { Route as AuthenticatedLeadsLeadIdCustomerImport } from './routes/_authenticated/leads/lead/$id/customer'
import { Route as AuthenticatedLeadsLeadIdChangesImport } from './routes/_authenticated/leads/lead/$id/changes'
import { Route as AuthenticatedLeadsLeadIdCciImport } from './routes/_authenticated/leads/lead/$id/cci'
import { Route as AuthenticatedLeadsLeadIdCallsImport } from './routes/_authenticated/leads/lead/$id/calls'
import { Route as AuthenticatedEventsEventIdPaymentsImport } from './routes/_authenticated/events/event/$id/payments'
import { Route as AuthenticatedEventsEventIdOverviewImport } from './routes/_authenticated/events/event/$id/overview'
import { Route as AuthenticatedEventsEventIdMessagesImport } from './routes/_authenticated/events/event/$id/messages'
import { Route as AuthenticatedEventsEventIdInvoiceImport } from './routes/_authenticated/events/event/$id/invoice'
import { Route as AuthenticatedEventsEventIdEsignImport } from './routes/_authenticated/events/event/$id/esign'
import { Route as AuthenticatedEventsEventIdEditImport } from './routes/_authenticated/events/event/$id/edit'
import { Route as AuthenticatedEventsEventIdCustomerImport } from './routes/_authenticated/events/event/$id/customer'
import { Route as AuthenticatedEventsEventIdChangesImport } from './routes/_authenticated/events/event/$id/changes'
import { Route as AuthenticatedEventsEventIdCciImport } from './routes/_authenticated/events/event/$id/cci'
import { Route as AuthenticatedEventsEventIdCallsImport } from './routes/_authenticated/events/event/$id/calls'
import { Route as AuthenticatedCustomersCustomerIdOverviewImport } from './routes/_authenticated/customers/customer/$id/overview'
import { Route as AuthenticatedCustomersCustomerIdCallsImport } from './routes/_authenticated/customers/customer/$id/calls'
import { Route as FramelessFsEquipmentInspectionsInspectionidInspectionLogsNewImport } from './routes/_frameless/fs/equipment/inspections/$inspection_id/inspection-logs/new'
import { Route as FramelessFsEquipmentInspectionsInspectionidInspectionLogsIdImport } from './routes/_frameless/fs/equipment/inspections/$inspection_id/inspection-logs/$id'

// Create Virtual Routes

const AuthenticatedHelpLazyImport = createFileRoute('/_authenticated/help')()
const AuthenticatedSettingsRouteLazyImport = createFileRoute(
  '/_authenticated/settings',
)()
const AuthenticatedResourcesRouteLazyImport = createFileRoute(
  '/_authenticated/resources',
)()
const AuthenticatedReportsRouteLazyImport = createFileRoute(
  '/_authenticated/reports',
)()
const AuthenticatedProductsRouteLazyImport = createFileRoute(
  '/_authenticated/products',
)()
const AuthenticatedEquipmentRouteLazyImport = createFileRoute(
  '/_authenticated/equipment',
)()
const AuthenticatedAccountRouteLazyImport = createFileRoute(
  '/_authenticated/account',
)()
const AuthenticatedConversationsIndexLazyImport = createFileRoute(
  '/_authenticated/conversations/',
)()
const PublicPasswordForgotLazyImport = createFileRoute(
  '/_public/password/forgot',
)()
const AuthenticatedSettingsSocialMediaLazyImport = createFileRoute(
  '/_authenticated/settings/social-media',
)()
const AuthenticatedSettingsSalesTeamLazyImport = createFileRoute(
  '/_authenticated/settings/sales-team',
)()
const AuthenticatedSettingsPowerupsLazyImport = createFileRoute(
  '/_authenticated/settings/powerups',
)()
const AuthenticatedSettingsPoliciesLazyImport = createFileRoute(
  '/_authenticated/settings/policies',
)()
const AuthenticatedSettingsNotificationsLazyImport = createFileRoute(
  '/_authenticated/settings/notifications',
)()
const AuthenticatedSettingsGeneralLazyImport = createFileRoute(
  '/_authenticated/settings/general',
)()
const AuthenticatedSettingsFaqsLazyImport = createFileRoute(
  '/_authenticated/settings/faqs',
)()
const AuthenticatedSettingsBusinessLazyImport = createFileRoute(
  '/_authenticated/settings/business',
)()
const AuthenticatedSettingsAdvancedLazyImport = createFileRoute(
  '/_authenticated/settings/advanced',
)()
const AuthenticatedSettingsAccountingLazyImport = createFileRoute(
  '/_authenticated/settings/accounting',
)()
const AuthenticatedSettingsAccessLazyImport = createFileRoute(
  '/_authenticated/settings/access',
)()
const AuthenticatedResourcesStripeLazyImport = createFileRoute(
  '/_authenticated/resources/stripe',
)()
const AuthenticatedResourcesStoreLazyImport = createFileRoute(
  '/_authenticated/resources/store',
)()
const AuthenticatedResourcesDirectoryLazyImport = createFileRoute(
  '/_authenticated/resources/directory',
)()
const AuthenticatedReportsSystemScorecardLazyImport = createFileRoute(
  '/_authenticated/reports/system-scorecard',
)()
const AuthenticatedReportsLocationScorecardLazyImport = createFileRoute(
  '/_authenticated/reports/location-scorecard',
)()
const AuthenticatedReportsDashboardLazyImport = createFileRoute(
  '/_authenticated/reports/dashboard',
)()
const AuthenticatedMapTabLazyImport = createFileRoute(
  '/_authenticated/map/$tab',
)()
const AuthenticatedLeaderboardTabLazyImport = createFileRoute(
  '/_authenticated/leaderboard/$tab',
)()
const AuthenticatedCallcenterTeamLazyImport = createFileRoute(
  '/_authenticated/callcenter/team',
)()
const AuthenticatedCallcenterPoolReportLazyImport = createFileRoute(
  '/_authenticated/callcenter/pool-report',
)()
const AuthenticatedAccountVirtualBusinessCardLazyImport = createFileRoute(
  '/_authenticated/account/virtual-business-card',
)()
const AuthenticatedAccountUserProfileLazyImport = createFileRoute(
  '/_authenticated/account/user-profile',
)()
const AuthenticatedAccountStripeAuthorizationLazyImport = createFileRoute(
  '/_authenticated/account/stripe-authorization',
)()
const AuthenticatedAccountInstagramAuthorizationLazyImport = createFileRoute(
  '/_authenticated/account/instagram-authorization',
)()
const AuthenticatedCustomersRewardsRouteLazyImport = createFileRoute(
  '/_authenticated/customers/rewards',
)()
const AuthenticatedSettingsReferralCampaignIndexLazyImport = createFileRoute(
  '/_authenticated/settings/referral-campaign/',
)()
const AuthenticatedProductsServicesIndexLazyImport = createFileRoute(
  '/_authenticated/products/services/',
)()
const AuthenticatedProductsPackagesIndexLazyImport = createFileRoute(
  '/_authenticated/products/packages/',
)()
const AuthenticatedProductsCouponsIndexLazyImport = createFileRoute(
  '/_authenticated/products/coupons/',
)()
const AuthenticatedProductsAddonsIndexLazyImport = createFileRoute(
  '/_authenticated/products/addons/',
)()
const AuthenticatedEquipmentWorkOrdersIndexLazyImport = createFileRoute(
  '/_authenticated/equipment/work-orders/',
)()
const AuthenticatedEquipmentVehiclesIndexLazyImport = createFileRoute(
  '/_authenticated/equipment/vehicles/',
)()
const AuthenticatedEquipmentGeneratorsIndexLazyImport = createFileRoute(
  '/_authenticated/equipment/generators/',
)()
const AuthenticatedEquipmentDepotsIndexLazyImport = createFileRoute(
  '/_authenticated/equipment/depots/',
)()
const AuthenticatedEquipmentDashboardIndexLazyImport = createFileRoute(
  '/_authenticated/equipment/dashboard/',
)()
const AuthenticatedEquipmentCalendarIndexLazyImport = createFileRoute(
  '/_authenticated/equipment/calendar/',
)()
const AuthenticatedEquipmentAssetsIndexLazyImport = createFileRoute(
  '/_authenticated/equipment/assets/',
)()
const AuthenticatedCustomersListsIndexLazyImport = createFileRoute(
  '/_authenticated/customers/lists/',
)()
const PublicPasswordResetTokenLazyImport = createFileRoute(
  '/_public/password/reset/$token',
)()
const AuthenticatedSettingsReferralCampaignCodeLazyImport = createFileRoute(
  '/_authenticated/settings/referral-campaign/code',
)()
const AuthenticatedReportsSalesSalesTeamLazyImport = createFileRoute(
  '/_authenticated/reports/sales/sales-team',
)()
const AuthenticatedReportsSalesOverviewLazyImport = createFileRoute(
  '/_authenticated/reports/sales/overview',
)()
const AuthenticatedReportsSalesEventTypeLazyImport = createFileRoute(
  '/_authenticated/reports/sales/event-type',
)()
const AuthenticatedReportsSalesDetailLazyImport = createFileRoute(
  '/_authenticated/reports/sales/detail',
)()
const AuthenticatedReportsSalesActivityTypeLazyImport = createFileRoute(
  '/_authenticated/reports/sales/activity-type',
)()
const AuthenticatedReportsRevenueSalesTaxLazyImport = createFileRoute(
  '/_authenticated/reports/revenue/sales-tax',
)()
const AuthenticatedReportsRevenueOverviewLazyImport = createFileRoute(
  '/_authenticated/reports/revenue/overview',
)()
const AuthenticatedReportsRevenueEventTypeLazyImport = createFileRoute(
  '/_authenticated/reports/revenue/event-type',
)()
const AuthenticatedReportsRevenueCollectedPaymentsLazyImport = createFileRoute(
  '/_authenticated/reports/revenue/collected-payments',
)()
const AuthenticatedReportsRevenueActivityTypeLazyImport = createFileRoute(
  '/_authenticated/reports/revenue/activity-type',
)()
const AuthenticatedReportsOpsNpsLazyImport = createFileRoute(
  '/_authenticated/reports/ops/nps',
)()
const AuthenticatedReportsMarketingOverviewLazyImport = createFileRoute(
  '/_authenticated/reports/marketing/overview',
)()
const AuthenticatedReportsMarketingLeadsLazyImport = createFileRoute(
  '/_authenticated/reports/marketing/leads',
)()
const AuthenticatedReportsFinanceCashLazyImport = createFileRoute(
  '/_authenticated/reports/finance/cash',
)()
const AuthenticatedReportsCallcenterSpeedToLeadLazyImport = createFileRoute(
  '/_authenticated/reports/callcenter/speed-to-lead',
)()
const AuthenticatedReportsCallcenterMissedLeadsLazyImport = createFileRoute(
  '/_authenticated/reports/callcenter/missed-leads',
)()
const AuthenticatedReportsCallcenterConversationsLazyImport = createFileRoute(
  '/_authenticated/reports/callcenter/conversations',
)()
const AuthenticatedReportsCallcenterCloseRateLazyImport = createFileRoute(
  '/_authenticated/reports/callcenter/close-rate',
)()
const AuthenticatedProductsServicesNewLazyImport = createFileRoute(
  '/_authenticated/products/services/new',
)()
const AuthenticatedProductsServicesIdLazyImport = createFileRoute(
  '/_authenticated/products/services/$id',
)()
const AuthenticatedProductsPackagesNewLazyImport = createFileRoute(
  '/_authenticated/products/packages/new',
)()
const AuthenticatedProductsPackagesIdLazyImport = createFileRoute(
  '/_authenticated/products/packages/$id',
)()
const AuthenticatedProductsCouponsNewLazyImport = createFileRoute(
  '/_authenticated/products/coupons/new',
)()
const AuthenticatedProductsCouponsIdLazyImport = createFileRoute(
  '/_authenticated/products/coupons/$id',
)()
const AuthenticatedLeadsLeadIdLazyImport = createFileRoute(
  '/_authenticated/leads/lead/$id',
)()
const AuthenticatedEquipmentWorkOrdersNewLazyImport = createFileRoute(
  '/_authenticated/equipment/work-orders/new',
)()
const AuthenticatedEquipmentWorkOrdersIdLazyImport = createFileRoute(
  '/_authenticated/equipment/work-orders/$id',
)()
const AuthenticatedEquipmentVehiclesNewLazyImport = createFileRoute(
  '/_authenticated/equipment/vehicles/new',
)()
const AuthenticatedEquipmentVehiclesIdLazyImport = createFileRoute(
  '/_authenticated/equipment/vehicles/$id',
)()
const AuthenticatedEquipmentUnitsIdLazyImport = createFileRoute(
  '/_authenticated/equipment/units/$id',
)()
const AuthenticatedEquipmentGeneratorsIdLazyImport = createFileRoute(
  '/_authenticated/equipment/generators/$id',
)()
const AuthenticatedEquipmentDepotsNewLazyImport = createFileRoute(
  '/_authenticated/equipment/depots/new',
)()
const AuthenticatedEquipmentDepotsIdLazyImport = createFileRoute(
  '/_authenticated/equipment/depots/$id',
)()
const AuthenticatedEquipmentAssetsNewLazyImport = createFileRoute(
  '/_authenticated/equipment/assets/new',
)()
const AuthenticatedEquipmentAssetsIdLazyImport = createFileRoute(
  '/_authenticated/equipment/assets/$id',
)()
const AuthenticatedCustomersListsNewLazyImport = createFileRoute(
  '/_authenticated/customers/lists/new',
)()
const AuthenticatedCustomersListsIdLazyImport = createFileRoute(
  '/_authenticated/customers/lists/$id',
)()
const AuthenticatedProductsAddonsProductidNewLazyImport = createFileRoute(
  '/_authenticated/products/addons/$product_id/new',
)()
const AuthenticatedProductsAddonsProductidIdLazyImport = createFileRoute(
  '/_authenticated/products/addons/$product_id/$id',
)()
const AuthenticatedLeadsLeadIdAcceptTransferLazyImport = createFileRoute(
  '/_authenticated/leads/lead/$id/accept-transfer',
)()
const AuthenticatedEventsEventIdAcceptTransferLazyImport = createFileRoute(
  '/_authenticated/events/event/$id/accept-transfer',
)()
const AuthenticatedEquipmentMaintenanceSchedulesNewLazyImport = createFileRoute(
  '/_authenticated/equipment/maintenance/schedules/new',
)()
const AuthenticatedEquipmentMaintenanceSchedulesIdLazyImport = createFileRoute(
  '/_authenticated/equipment/maintenance/schedules/$id',
)()
const AuthenticatedEquipmentMaintenanceInspectionsNewLazyImport =
  createFileRoute('/_authenticated/equipment/maintenance/inspections/new')()
const AuthenticatedEquipmentMaintenanceInspectionsIdLazyImport =
  createFileRoute('/_authenticated/equipment/maintenance/inspections/$id')()
const AuthenticatedCustomersCustomerIdPaymentsLazyImport = createFileRoute(
  '/_authenticated/customers/customer/$id/payments',
)()
const AuthenticatedCustomersCustomerIdMessagesLazyImport = createFileRoute(
  '/_authenticated/customers/customer/$id/messages',
)()
const AuthenticatedCustomersCustomerIdLeadsLazyImport = createFileRoute(
  '/_authenticated/customers/customer/$id/leads',
)()
const AuthenticatedCustomersCustomerIdEventsLazyImport = createFileRoute(
  '/_authenticated/customers/customer/$id/events',
)()
const AuthenticatedCustomersCustomerIdEditLazyImport = createFileRoute(
  '/_authenticated/customers/customer/$id/edit',
)()
const AuthenticatedCustomersCustomerIdChangesLazyImport = createFileRoute(
  '/_authenticated/customers/customer/$id/changes',
)()

// Create/Update Routes

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const FramelessRoute = FramelessImport.update({
  id: '/_frameless',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedHelpLazyRoute = AuthenticatedHelpLazyImport.update({
  path: '/help',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/help.lazy').then((d) => d.Route),
)

const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyImport.update({
    path: '/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )

const AuthenticatedResourcesRouteLazyRoute =
  AuthenticatedResourcesRouteLazyImport.update({
    path: '/resources',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/resources/route.lazy').then((d) => d.Route),
  )

const AuthenticatedReportsRouteLazyRoute =
  AuthenticatedReportsRouteLazyImport.update({
    path: '/reports',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/route.lazy').then((d) => d.Route),
  )

const AuthenticatedProductsRouteLazyRoute =
  AuthenticatedProductsRouteLazyImport.update({
    path: '/products',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/route.lazy').then((d) => d.Route),
  )

const AuthenticatedEquipmentRouteLazyRoute =
  AuthenticatedEquipmentRouteLazyImport.update({
    path: '/equipment',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/route.lazy').then((d) => d.Route),
  )

const AuthenticatedAccountRouteLazyRoute =
  AuthenticatedAccountRouteLazyImport.update({
    path: '/account',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/account/route.lazy').then((d) => d.Route),
  )

const PublicLoginRoute = PublicLoginImport.update({
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)

const AuthenticatedDashboardRoute = AuthenticatedDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedSchedulerRouteRoute =
  AuthenticatedSchedulerRouteImport.update({
    path: '/scheduler',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCalendarRouteRoute = AuthenticatedCalendarRouteImport.update(
  {
    path: '/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedConversationsIndexLazyRoute =
  AuthenticatedConversationsIndexLazyImport.update({
    path: '/conversations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/conversations/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PublicPasswordForgotLazyRoute = PublicPasswordForgotLazyImport.update({
  path: '/password/forgot',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public/password.forgot.lazy').then((d) => d.Route),
)

const AuthenticatedSettingsSocialMediaLazyRoute =
  AuthenticatedSettingsSocialMediaLazyImport.update({
    path: '/social-media',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/social-media.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsSalesTeamLazyRoute =
  AuthenticatedSettingsSalesTeamLazyImport.update({
    path: '/sales-team',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/sales-team.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsPowerupsLazyRoute =
  AuthenticatedSettingsPowerupsLazyImport.update({
    path: '/powerups',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/powerups.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsPoliciesLazyRoute =
  AuthenticatedSettingsPoliciesLazyImport.update({
    path: '/policies',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/policies.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsNotificationsLazyRoute =
  AuthenticatedSettingsNotificationsLazyImport.update({
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/notifications.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsGeneralLazyRoute =
  AuthenticatedSettingsGeneralLazyImport.update({
    path: '/general',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/general.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsFaqsLazyRoute =
  AuthenticatedSettingsFaqsLazyImport.update({
    path: '/faqs',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/faqs.lazy').then((d) => d.Route),
  )

const AuthenticatedSettingsBusinessLazyRoute =
  AuthenticatedSettingsBusinessLazyImport.update({
    path: '/business',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/business.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsAdvancedLazyRoute =
  AuthenticatedSettingsAdvancedLazyImport.update({
    path: '/advanced',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/advanced.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsAccountingLazyRoute =
  AuthenticatedSettingsAccountingLazyImport.update({
    path: '/accounting',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/accounting.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedSettingsAccessLazyRoute =
  AuthenticatedSettingsAccessLazyImport.update({
    path: '/access',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/access.lazy').then((d) => d.Route),
  )

const AuthenticatedResourcesStripeLazyRoute =
  AuthenticatedResourcesStripeLazyImport.update({
    path: '/stripe',
    getParentRoute: () => AuthenticatedResourcesRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/resources/stripe.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedResourcesStoreLazyRoute =
  AuthenticatedResourcesStoreLazyImport.update({
    path: '/store',
    getParentRoute: () => AuthenticatedResourcesRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/resources/store.lazy').then((d) => d.Route),
  )

const AuthenticatedResourcesDirectoryLazyRoute =
  AuthenticatedResourcesDirectoryLazyImport.update({
    path: '/directory',
    getParentRoute: () => AuthenticatedResourcesRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/resources/directory.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsSystemScorecardLazyRoute =
  AuthenticatedReportsSystemScorecardLazyImport.update({
    path: '/system-scorecard',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/system-scorecard.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsLocationScorecardLazyRoute =
  AuthenticatedReportsLocationScorecardLazyImport.update({
    path: '/location-scorecard',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/location-scorecard.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsDashboardLazyRoute =
  AuthenticatedReportsDashboardLazyImport.update({
    path: '/dashboard',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/dashboard.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedMapTabLazyRoute = AuthenticatedMapTabLazyImport.update({
  path: '/map/$tab',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/map/$tab.lazy').then((d) => d.Route),
)

const AuthenticatedLeaderboardTabLazyRoute =
  AuthenticatedLeaderboardTabLazyImport.update({
    path: '/leaderboard/$tab',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/leaderboard.$tab.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCallcenterTeamLazyRoute =
  AuthenticatedCallcenterTeamLazyImport.update({
    path: '/callcenter/team',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/callcenter/team.lazy').then((d) => d.Route),
  )

const AuthenticatedCallcenterPoolReportLazyRoute =
  AuthenticatedCallcenterPoolReportLazyImport.update({
    path: '/callcenter/pool-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/callcenter/pool-report.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedAccountVirtualBusinessCardLazyRoute =
  AuthenticatedAccountVirtualBusinessCardLazyImport.update({
    path: '/virtual-business-card',
    getParentRoute: () => AuthenticatedAccountRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/account/virtual-business-card.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedAccountUserProfileLazyRoute =
  AuthenticatedAccountUserProfileLazyImport.update({
    path: '/user-profile',
    getParentRoute: () => AuthenticatedAccountRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/account/user-profile.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedAccountStripeAuthorizationLazyRoute =
  AuthenticatedAccountStripeAuthorizationLazyImport.update({
    path: '/stripe-authorization',
    getParentRoute: () => AuthenticatedAccountRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/account/stripe-authorization.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedAccountInstagramAuthorizationLazyRoute =
  AuthenticatedAccountInstagramAuthorizationLazyImport.update({
    path: '/instagram-authorization',
    getParentRoute: () => AuthenticatedAccountRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/account/instagram-authorization.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersRewardsRouteLazyRoute =
  AuthenticatedCustomersRewardsRouteLazyImport.update({
    path: '/customers/rewards',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/rewards/route.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedLeadsFilterRouteRoute =
  AuthenticatedLeadsFilterRouteImport.update({
    path: '/leads/$filter',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedEventsFilterRouteRoute =
  AuthenticatedEventsFilterRouteImport.update({
    path: '/events/$filter',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCustomersFilterRouteRoute =
  AuthenticatedCustomersFilterRouteImport.update({
    path: '/customers/$filter',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSettingsReferralCampaignIndexLazyRoute =
  AuthenticatedSettingsReferralCampaignIndexLazyImport.update({
    path: '/referral-campaign/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/referral-campaign/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsServicesIndexLazyRoute =
  AuthenticatedProductsServicesIndexLazyImport.update({
    path: '/services/',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/services/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsPackagesIndexLazyRoute =
  AuthenticatedProductsPackagesIndexLazyImport.update({
    path: '/packages/',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/packages/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsCouponsIndexLazyRoute =
  AuthenticatedProductsCouponsIndexLazyImport.update({
    path: '/coupons/',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/coupons/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsAddonsIndexLazyRoute =
  AuthenticatedProductsAddonsIndexLazyImport.update({
    path: '/addons/',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/addons/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentWorkOrdersIndexLazyRoute =
  AuthenticatedEquipmentWorkOrdersIndexLazyImport.update({
    path: '/work-orders/',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/work-orders/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentVehiclesIndexLazyRoute =
  AuthenticatedEquipmentVehiclesIndexLazyImport.update({
    path: '/vehicles/',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/vehicles/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentGeneratorsIndexLazyRoute =
  AuthenticatedEquipmentGeneratorsIndexLazyImport.update({
    path: '/generators/',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/generators/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentDepotsIndexLazyRoute =
  AuthenticatedEquipmentDepotsIndexLazyImport.update({
    path: '/depots/',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/depots/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentDashboardIndexLazyRoute =
  AuthenticatedEquipmentDashboardIndexLazyImport.update({
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentCalendarIndexLazyRoute =
  AuthenticatedEquipmentCalendarIndexLazyImport.update({
    path: '/calendar/',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/calendar/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentAssetsIndexLazyRoute =
  AuthenticatedEquipmentAssetsIndexLazyImport.update({
    path: '/assets/',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/assets/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersListsIndexLazyRoute =
  AuthenticatedCustomersListsIndexLazyImport.update({
    path: '/customers/lists/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/lists/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedLeadsFilterIndexRoute =
  AuthenticatedLeadsFilterIndexImport.update({
    path: '/',
    getParentRoute: () => AuthenticatedLeadsFilterRouteRoute,
  } as any)

const AuthenticatedEventsFilterIndexRoute =
  AuthenticatedEventsFilterIndexImport.update({
    path: '/',
    getParentRoute: () => AuthenticatedEventsFilterRouteRoute,
  } as any)

const AuthenticatedCustomersFilterIndexRoute =
  AuthenticatedCustomersFilterIndexImport.update({
    path: '/',
    getParentRoute: () => AuthenticatedCustomersFilterRouteRoute,
  } as any)

const PublicPasswordResetTokenLazyRoute =
  PublicPasswordResetTokenLazyImport.update({
    path: '/password/reset/$token',
    getParentRoute: () => PublicRoute,
  } as any).lazy(() =>
    import('./routes/_public/password.reset.$token.lazy').then((d) => d.Route),
  )

const AuthenticatedSettingsReferralCampaignCodeLazyRoute =
  AuthenticatedSettingsReferralCampaignCodeLazyImport.update({
    path: '/referral-campaign/code',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/referral-campaign/code.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsSalesSalesTeamLazyRoute =
  AuthenticatedReportsSalesSalesTeamLazyImport.update({
    path: '/sales/sales-team',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/sales/sales-team.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsSalesOverviewLazyRoute =
  AuthenticatedReportsSalesOverviewLazyImport.update({
    path: '/sales/overview',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/sales/overview.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsSalesEventTypeLazyRoute =
  AuthenticatedReportsSalesEventTypeLazyImport.update({
    path: '/sales/event-type',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/sales/event-type.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsSalesDetailLazyRoute =
  AuthenticatedReportsSalesDetailLazyImport.update({
    path: '/sales/detail',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/sales/detail.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsSalesActivityTypeLazyRoute =
  AuthenticatedReportsSalesActivityTypeLazyImport.update({
    path: '/sales/activity-type',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/sales/activity-type.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsRevenueSalesTaxLazyRoute =
  AuthenticatedReportsRevenueSalesTaxLazyImport.update({
    path: '/revenue/sales-tax',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/revenue/sales-tax.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsRevenueOverviewLazyRoute =
  AuthenticatedReportsRevenueOverviewLazyImport.update({
    path: '/revenue/overview',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/revenue/overview.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsRevenueEventTypeLazyRoute =
  AuthenticatedReportsRevenueEventTypeLazyImport.update({
    path: '/revenue/event-type',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/revenue/event-type.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsRevenueCollectedPaymentsLazyRoute =
  AuthenticatedReportsRevenueCollectedPaymentsLazyImport.update({
    path: '/revenue/collected-payments',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/revenue/collected-payments.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsRevenueActivityTypeLazyRoute =
  AuthenticatedReportsRevenueActivityTypeLazyImport.update({
    path: '/revenue/activity-type',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/revenue/activity-type.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsOpsNpsLazyRoute =
  AuthenticatedReportsOpsNpsLazyImport.update({
    path: '/ops/nps',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/ops/nps.lazy').then((d) => d.Route),
  )

const AuthenticatedReportsMarketingOverviewLazyRoute =
  AuthenticatedReportsMarketingOverviewLazyImport.update({
    path: '/marketing/overview',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/marketing/overview.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsMarketingLeadsLazyRoute =
  AuthenticatedReportsMarketingLeadsLazyImport.update({
    path: '/marketing/leads',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/marketing/leads.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsFinanceCashLazyRoute =
  AuthenticatedReportsFinanceCashLazyImport.update({
    path: '/finance/cash',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/finance/cash.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsCallcenterSpeedToLeadLazyRoute =
  AuthenticatedReportsCallcenterSpeedToLeadLazyImport.update({
    path: '/callcenter/speed-to-lead',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/callcenter/speed-to-lead.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsCallcenterMissedLeadsLazyRoute =
  AuthenticatedReportsCallcenterMissedLeadsLazyImport.update({
    path: '/callcenter/missed-leads',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/callcenter/missed-leads.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsCallcenterConversationsLazyRoute =
  AuthenticatedReportsCallcenterConversationsLazyImport.update({
    path: '/callcenter/conversations',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/callcenter/conversations.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedReportsCallcenterCloseRateLazyRoute =
  AuthenticatedReportsCallcenterCloseRateLazyImport.update({
    path: '/callcenter/close-rate',
    getParentRoute: () => AuthenticatedReportsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/reports/callcenter/close-rate.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsServicesNewLazyRoute =
  AuthenticatedProductsServicesNewLazyImport.update({
    path: '/services/new',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/services/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsServicesIdLazyRoute =
  AuthenticatedProductsServicesIdLazyImport.update({
    path: '/services/$id',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/services/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsPackagesNewLazyRoute =
  AuthenticatedProductsPackagesNewLazyImport.update({
    path: '/packages/new',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/packages/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsPackagesIdLazyRoute =
  AuthenticatedProductsPackagesIdLazyImport.update({
    path: '/packages/$id',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/packages/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsCouponsNewLazyRoute =
  AuthenticatedProductsCouponsNewLazyImport.update({
    path: '/coupons/new',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/coupons/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsCouponsIdLazyRoute =
  AuthenticatedProductsCouponsIdLazyImport.update({
    path: '/coupons/$id',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/coupons/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedLeadsLeadIdLazyRoute =
  AuthenticatedLeadsLeadIdLazyImport.update({
    path: '/leads/lead/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/leads/lead/$id.lazy').then((d) => d.Route),
  )

const AuthenticatedEquipmentWorkOrdersNewLazyRoute =
  AuthenticatedEquipmentWorkOrdersNewLazyImport.update({
    path: '/work-orders/new',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/work-orders/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentWorkOrdersIdLazyRoute =
  AuthenticatedEquipmentWorkOrdersIdLazyImport.update({
    path: '/work-orders/$id',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/work-orders/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentVehiclesNewLazyRoute =
  AuthenticatedEquipmentVehiclesNewLazyImport.update({
    path: '/vehicles/new',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/vehicles/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentVehiclesIdLazyRoute =
  AuthenticatedEquipmentVehiclesIdLazyImport.update({
    path: '/vehicles/$id',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/vehicles/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentUnitsIdLazyRoute =
  AuthenticatedEquipmentUnitsIdLazyImport.update({
    path: '/units/$id',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/units/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentGeneratorsIdLazyRoute =
  AuthenticatedEquipmentGeneratorsIdLazyImport.update({
    path: '/generators/$id',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/generators/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentDepotsNewLazyRoute =
  AuthenticatedEquipmentDepotsNewLazyImport.update({
    path: '/depots/new',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/depots/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentDepotsIdLazyRoute =
  AuthenticatedEquipmentDepotsIdLazyImport.update({
    path: '/depots/$id',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/depots/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentAssetsNewLazyRoute =
  AuthenticatedEquipmentAssetsNewLazyImport.update({
    path: '/assets/new',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/assets/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentAssetsIdLazyRoute =
  AuthenticatedEquipmentAssetsIdLazyImport.update({
    path: '/assets/$id',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/assets/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersListsNewLazyRoute =
  AuthenticatedCustomersListsNewLazyImport.update({
    path: '/customers/lists/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/lists/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersListsIdLazyRoute =
  AuthenticatedCustomersListsIdLazyImport.update({
    path: '/customers/lists/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/lists/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEventsToolsGapFinderRoute =
  AuthenticatedEventsToolsGapFinderImport.update({
    path: '/events/tools/gap-finder',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedEventsToolsEventPacksRoute =
  AuthenticatedEventsToolsEventPacksImport.update({
    path: '/events/tools/event-packs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedEventsEventIdRoute = AuthenticatedEventsEventIdImport.update(
  {
    path: '/events/event/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedCustomersCustomerIdRoute =
  AuthenticatedCustomersCustomerIdImport.update({
    path: '/customers/customer/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedProductsAddonsProductidNewLazyRoute =
  AuthenticatedProductsAddonsProductidNewLazyImport.update({
    path: '/addons/$product_id/new',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/addons/$product_id.new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedProductsAddonsProductidIdLazyRoute =
  AuthenticatedProductsAddonsProductidIdLazyImport.update({
    path: '/addons/$product_id/$id',
    getParentRoute: () => AuthenticatedProductsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products/addons/$product_id.$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedLeadsLeadIdAcceptTransferLazyRoute =
  AuthenticatedLeadsLeadIdAcceptTransferLazyImport.update({
    path: '/accept-transfer',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/leads/lead/$id.accept-transfer.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEventsEventIdAcceptTransferLazyRoute =
  AuthenticatedEventsEventIdAcceptTransferLazyImport.update({
    path: '/accept-transfer',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/events/event/$id.accept-transfer.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentMaintenanceSchedulesNewLazyRoute =
  AuthenticatedEquipmentMaintenanceSchedulesNewLazyImport.update({
    path: '/maintenance/schedules/new',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/maintenance/schedules/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentMaintenanceSchedulesIdLazyRoute =
  AuthenticatedEquipmentMaintenanceSchedulesIdLazyImport.update({
    path: '/maintenance/schedules/$id',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/maintenance/schedules/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentMaintenanceInspectionsNewLazyRoute =
  AuthenticatedEquipmentMaintenanceInspectionsNewLazyImport.update({
    path: '/maintenance/inspections/new',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/maintenance/inspections/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedEquipmentMaintenanceInspectionsIdLazyRoute =
  AuthenticatedEquipmentMaintenanceInspectionsIdLazyImport.update({
    path: '/maintenance/inspections/$id',
    getParentRoute: () => AuthenticatedEquipmentRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/equipment/maintenance/inspections/$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersCustomerIdPaymentsLazyRoute =
  AuthenticatedCustomersCustomerIdPaymentsLazyImport.update({
    path: '/payments',
    getParentRoute: () => AuthenticatedCustomersCustomerIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/customer/$id/payments.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersCustomerIdMessagesLazyRoute =
  AuthenticatedCustomersCustomerIdMessagesLazyImport.update({
    path: '/messages',
    getParentRoute: () => AuthenticatedCustomersCustomerIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/customer/$id/messages.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersCustomerIdLeadsLazyRoute =
  AuthenticatedCustomersCustomerIdLeadsLazyImport.update({
    path: '/leads',
    getParentRoute: () => AuthenticatedCustomersCustomerIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/customer/$id/leads.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersCustomerIdEventsLazyRoute =
  AuthenticatedCustomersCustomerIdEventsLazyImport.update({
    path: '/events',
    getParentRoute: () => AuthenticatedCustomersCustomerIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/customer/$id/events.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersCustomerIdEditLazyRoute =
  AuthenticatedCustomersCustomerIdEditLazyImport.update({
    path: '/edit',
    getParentRoute: () => AuthenticatedCustomersCustomerIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/customer/$id/edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedCustomersCustomerIdChangesLazyRoute =
  AuthenticatedCustomersCustomerIdChangesLazyImport.update({
    path: '/changes',
    getParentRoute: () => AuthenticatedCustomersCustomerIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customers/customer/$id/changes.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedLeadsLeadIdReviewRoute =
  AuthenticatedLeadsLeadIdReviewImport.update({
    path: '/review',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any)

const AuthenticatedLeadsLeadIdQuoteRoute =
  AuthenticatedLeadsLeadIdQuoteImport.update({
    path: '/quote',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any)

const AuthenticatedLeadsLeadIdPricingRoute =
  AuthenticatedLeadsLeadIdPricingImport.update({
    path: '/pricing',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any)

const AuthenticatedLeadsLeadIdMessagesRoute =
  AuthenticatedLeadsLeadIdMessagesImport.update({
    path: '/messages',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any)

const AuthenticatedLeadsLeadIdCustomerRoute =
  AuthenticatedLeadsLeadIdCustomerImport.update({
    path: '/customer',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any)

const AuthenticatedLeadsLeadIdChangesRoute =
  AuthenticatedLeadsLeadIdChangesImport.update({
    path: '/changes',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any)

const AuthenticatedLeadsLeadIdCciRoute =
  AuthenticatedLeadsLeadIdCciImport.update({
    path: '/cci',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any)

const AuthenticatedLeadsLeadIdCallsRoute =
  AuthenticatedLeadsLeadIdCallsImport.update({
    path: '/calls',
    getParentRoute: () => AuthenticatedLeadsLeadIdLazyRoute,
  } as any)

const AuthenticatedEventsEventIdPaymentsRoute =
  AuthenticatedEventsEventIdPaymentsImport.update({
    path: '/payments',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdOverviewRoute =
  AuthenticatedEventsEventIdOverviewImport.update({
    path: '/overview',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdMessagesRoute =
  AuthenticatedEventsEventIdMessagesImport.update({
    path: '/messages',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdInvoiceRoute =
  AuthenticatedEventsEventIdInvoiceImport.update({
    path: '/invoice',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdEsignRoute =
  AuthenticatedEventsEventIdEsignImport.update({
    path: '/esign',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdEditRoute =
  AuthenticatedEventsEventIdEditImport.update({
    path: '/edit',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdCustomerRoute =
  AuthenticatedEventsEventIdCustomerImport.update({
    path: '/customer',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdChangesRoute =
  AuthenticatedEventsEventIdChangesImport.update({
    path: '/changes',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdCciRoute =
  AuthenticatedEventsEventIdCciImport.update({
    path: '/cci',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedEventsEventIdCallsRoute =
  AuthenticatedEventsEventIdCallsImport.update({
    path: '/calls',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)

const AuthenticatedCustomersCustomerIdOverviewRoute =
  AuthenticatedCustomersCustomerIdOverviewImport.update({
    path: '/overview',
    getParentRoute: () => AuthenticatedCustomersCustomerIdRoute,
  } as any)

const AuthenticatedCustomersCustomerIdCallsRoute =
  AuthenticatedCustomersCustomerIdCallsImport.update({
    path: '/calls',
    getParentRoute: () => AuthenticatedCustomersCustomerIdRoute,
  } as any)

const FramelessFsEquipmentInspectionsInspectionidInspectionLogsNewRoute =
  FramelessFsEquipmentInspectionsInspectionidInspectionLogsNewImport.update({
    path: '/fs/equipment/inspections/$inspection_id/inspection-logs/new',
    getParentRoute: () => FramelessRoute,
  } as any)

const FramelessFsEquipmentInspectionsInspectionidInspectionLogsIdRoute =
  FramelessFsEquipmentInspectionsInspectionidInspectionLogsIdImport.update({
    path: '/fs/equipment/inspections/$inspection_id/inspection-logs/$id',
    getParentRoute: () => FramelessRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_frameless': {
      preLoaderRoute: typeof FramelessImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/calendar': {
      preLoaderRoute: typeof AuthenticatedCalendarRouteImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/scheduler': {
      preLoaderRoute: typeof AuthenticatedSchedulerRouteImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/dashboard': {
      preLoaderRoute: typeof AuthenticatedDashboardImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_public/login': {
      preLoaderRoute: typeof PublicLoginImport
      parentRoute: typeof PublicImport
    }
    '/_authenticated/account': {
      preLoaderRoute: typeof AuthenticatedAccountRouteLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/equipment': {
      preLoaderRoute: typeof AuthenticatedEquipmentRouteLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/products': {
      preLoaderRoute: typeof AuthenticatedProductsRouteLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/reports': {
      preLoaderRoute: typeof AuthenticatedReportsRouteLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/resources': {
      preLoaderRoute: typeof AuthenticatedResourcesRouteLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings': {
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/help': {
      preLoaderRoute: typeof AuthenticatedHelpLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/customers/$filter': {
      preLoaderRoute: typeof AuthenticatedCustomersFilterRouteImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/events/$filter': {
      preLoaderRoute: typeof AuthenticatedEventsFilterRouteImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/leads/$filter': {
      preLoaderRoute: typeof AuthenticatedLeadsFilterRouteImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/customers/rewards': {
      preLoaderRoute: typeof AuthenticatedCustomersRewardsRouteLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/account/instagram-authorization': {
      preLoaderRoute: typeof AuthenticatedAccountInstagramAuthorizationLazyImport
      parentRoute: typeof AuthenticatedAccountRouteLazyImport
    }
    '/_authenticated/account/stripe-authorization': {
      preLoaderRoute: typeof AuthenticatedAccountStripeAuthorizationLazyImport
      parentRoute: typeof AuthenticatedAccountRouteLazyImport
    }
    '/_authenticated/account/user-profile': {
      preLoaderRoute: typeof AuthenticatedAccountUserProfileLazyImport
      parentRoute: typeof AuthenticatedAccountRouteLazyImport
    }
    '/_authenticated/account/virtual-business-card': {
      preLoaderRoute: typeof AuthenticatedAccountVirtualBusinessCardLazyImport
      parentRoute: typeof AuthenticatedAccountRouteLazyImport
    }
    '/_authenticated/callcenter/pool-report': {
      preLoaderRoute: typeof AuthenticatedCallcenterPoolReportLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/callcenter/team': {
      preLoaderRoute: typeof AuthenticatedCallcenterTeamLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/leaderboard/$tab': {
      preLoaderRoute: typeof AuthenticatedLeaderboardTabLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/map/$tab': {
      preLoaderRoute: typeof AuthenticatedMapTabLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/reports/dashboard': {
      preLoaderRoute: typeof AuthenticatedReportsDashboardLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/location-scorecard': {
      preLoaderRoute: typeof AuthenticatedReportsLocationScorecardLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/system-scorecard': {
      preLoaderRoute: typeof AuthenticatedReportsSystemScorecardLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/resources/directory': {
      preLoaderRoute: typeof AuthenticatedResourcesDirectoryLazyImport
      parentRoute: typeof AuthenticatedResourcesRouteLazyImport
    }
    '/_authenticated/resources/store': {
      preLoaderRoute: typeof AuthenticatedResourcesStoreLazyImport
      parentRoute: typeof AuthenticatedResourcesRouteLazyImport
    }
    '/_authenticated/resources/stripe': {
      preLoaderRoute: typeof AuthenticatedResourcesStripeLazyImport
      parentRoute: typeof AuthenticatedResourcesRouteLazyImport
    }
    '/_authenticated/settings/access': {
      preLoaderRoute: typeof AuthenticatedSettingsAccessLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/accounting': {
      preLoaderRoute: typeof AuthenticatedSettingsAccountingLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/advanced': {
      preLoaderRoute: typeof AuthenticatedSettingsAdvancedLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/business': {
      preLoaderRoute: typeof AuthenticatedSettingsBusinessLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/faqs': {
      preLoaderRoute: typeof AuthenticatedSettingsFaqsLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/general': {
      preLoaderRoute: typeof AuthenticatedSettingsGeneralLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/notifications': {
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/policies': {
      preLoaderRoute: typeof AuthenticatedSettingsPoliciesLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/powerups': {
      preLoaderRoute: typeof AuthenticatedSettingsPowerupsLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/sales-team': {
      preLoaderRoute: typeof AuthenticatedSettingsSalesTeamLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/settings/social-media': {
      preLoaderRoute: typeof AuthenticatedSettingsSocialMediaLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_public/password/forgot': {
      preLoaderRoute: typeof PublicPasswordForgotLazyImport
      parentRoute: typeof PublicImport
    }
    '/_authenticated/conversations/': {
      preLoaderRoute: typeof AuthenticatedConversationsIndexLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/customers/customer/$id': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/events/event/$id': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/events/tools/event-packs': {
      preLoaderRoute: typeof AuthenticatedEventsToolsEventPacksImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/events/tools/gap-finder': {
      preLoaderRoute: typeof AuthenticatedEventsToolsGapFinderImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/customers/lists/$id': {
      preLoaderRoute: typeof AuthenticatedCustomersListsIdLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/customers/lists/new': {
      preLoaderRoute: typeof AuthenticatedCustomersListsNewLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/equipment/assets/$id': {
      preLoaderRoute: typeof AuthenticatedEquipmentAssetsIdLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/assets/new': {
      preLoaderRoute: typeof AuthenticatedEquipmentAssetsNewLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/depots/$id': {
      preLoaderRoute: typeof AuthenticatedEquipmentDepotsIdLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/depots/new': {
      preLoaderRoute: typeof AuthenticatedEquipmentDepotsNewLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/generators/$id': {
      preLoaderRoute: typeof AuthenticatedEquipmentGeneratorsIdLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/units/$id': {
      preLoaderRoute: typeof AuthenticatedEquipmentUnitsIdLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/vehicles/$id': {
      preLoaderRoute: typeof AuthenticatedEquipmentVehiclesIdLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/vehicles/new': {
      preLoaderRoute: typeof AuthenticatedEquipmentVehiclesNewLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/work-orders/$id': {
      preLoaderRoute: typeof AuthenticatedEquipmentWorkOrdersIdLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/work-orders/new': {
      preLoaderRoute: typeof AuthenticatedEquipmentWorkOrdersNewLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/leads/lead/$id': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/products/coupons/$id': {
      preLoaderRoute: typeof AuthenticatedProductsCouponsIdLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/coupons/new': {
      preLoaderRoute: typeof AuthenticatedProductsCouponsNewLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/packages/$id': {
      preLoaderRoute: typeof AuthenticatedProductsPackagesIdLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/packages/new': {
      preLoaderRoute: typeof AuthenticatedProductsPackagesNewLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/services/$id': {
      preLoaderRoute: typeof AuthenticatedProductsServicesIdLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/services/new': {
      preLoaderRoute: typeof AuthenticatedProductsServicesNewLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/reports/callcenter/close-rate': {
      preLoaderRoute: typeof AuthenticatedReportsCallcenterCloseRateLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/callcenter/conversations': {
      preLoaderRoute: typeof AuthenticatedReportsCallcenterConversationsLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/callcenter/missed-leads': {
      preLoaderRoute: typeof AuthenticatedReportsCallcenterMissedLeadsLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/callcenter/speed-to-lead': {
      preLoaderRoute: typeof AuthenticatedReportsCallcenterSpeedToLeadLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/finance/cash': {
      preLoaderRoute: typeof AuthenticatedReportsFinanceCashLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/marketing/leads': {
      preLoaderRoute: typeof AuthenticatedReportsMarketingLeadsLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/marketing/overview': {
      preLoaderRoute: typeof AuthenticatedReportsMarketingOverviewLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/ops/nps': {
      preLoaderRoute: typeof AuthenticatedReportsOpsNpsLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/revenue/activity-type': {
      preLoaderRoute: typeof AuthenticatedReportsRevenueActivityTypeLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/revenue/collected-payments': {
      preLoaderRoute: typeof AuthenticatedReportsRevenueCollectedPaymentsLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/revenue/event-type': {
      preLoaderRoute: typeof AuthenticatedReportsRevenueEventTypeLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/revenue/overview': {
      preLoaderRoute: typeof AuthenticatedReportsRevenueOverviewLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/revenue/sales-tax': {
      preLoaderRoute: typeof AuthenticatedReportsRevenueSalesTaxLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/sales/activity-type': {
      preLoaderRoute: typeof AuthenticatedReportsSalesActivityTypeLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/sales/detail': {
      preLoaderRoute: typeof AuthenticatedReportsSalesDetailLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/sales/event-type': {
      preLoaderRoute: typeof AuthenticatedReportsSalesEventTypeLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/sales/overview': {
      preLoaderRoute: typeof AuthenticatedReportsSalesOverviewLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/reports/sales/sales-team': {
      preLoaderRoute: typeof AuthenticatedReportsSalesSalesTeamLazyImport
      parentRoute: typeof AuthenticatedReportsRouteLazyImport
    }
    '/_authenticated/settings/referral-campaign/code': {
      preLoaderRoute: typeof AuthenticatedSettingsReferralCampaignCodeLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_public/password/reset/$token': {
      preLoaderRoute: typeof PublicPasswordResetTokenLazyImport
      parentRoute: typeof PublicImport
    }
    '/_authenticated/customers/$filter/': {
      preLoaderRoute: typeof AuthenticatedCustomersFilterIndexImport
      parentRoute: typeof AuthenticatedCustomersFilterRouteImport
    }
    '/_authenticated/events/$filter/': {
      preLoaderRoute: typeof AuthenticatedEventsFilterIndexImport
      parentRoute: typeof AuthenticatedEventsFilterRouteImport
    }
    '/_authenticated/leads/$filter/': {
      preLoaderRoute: typeof AuthenticatedLeadsFilterIndexImport
      parentRoute: typeof AuthenticatedLeadsFilterRouteImport
    }
    '/_authenticated/customers/lists/': {
      preLoaderRoute: typeof AuthenticatedCustomersListsIndexLazyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/equipment/assets/': {
      preLoaderRoute: typeof AuthenticatedEquipmentAssetsIndexLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/calendar/': {
      preLoaderRoute: typeof AuthenticatedEquipmentCalendarIndexLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/dashboard/': {
      preLoaderRoute: typeof AuthenticatedEquipmentDashboardIndexLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/depots/': {
      preLoaderRoute: typeof AuthenticatedEquipmentDepotsIndexLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/generators/': {
      preLoaderRoute: typeof AuthenticatedEquipmentGeneratorsIndexLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/vehicles/': {
      preLoaderRoute: typeof AuthenticatedEquipmentVehiclesIndexLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/work-orders/': {
      preLoaderRoute: typeof AuthenticatedEquipmentWorkOrdersIndexLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/products/addons/': {
      preLoaderRoute: typeof AuthenticatedProductsAddonsIndexLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/coupons/': {
      preLoaderRoute: typeof AuthenticatedProductsCouponsIndexLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/packages/': {
      preLoaderRoute: typeof AuthenticatedProductsPackagesIndexLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/services/': {
      preLoaderRoute: typeof AuthenticatedProductsServicesIndexLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/settings/referral-campaign/': {
      preLoaderRoute: typeof AuthenticatedSettingsReferralCampaignIndexLazyImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyImport
    }
    '/_authenticated/customers/customer/$id/calls': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdCallsImport
      parentRoute: typeof AuthenticatedCustomersCustomerIdImport
    }
    '/_authenticated/customers/customer/$id/overview': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdOverviewImport
      parentRoute: typeof AuthenticatedCustomersCustomerIdImport
    }
    '/_authenticated/events/event/$id/calls': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdCallsImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/cci': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdCciImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/changes': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdChangesImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/customer': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdCustomerImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/edit': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdEditImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/esign': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdEsignImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/invoice': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdInvoiceImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/messages': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdMessagesImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/overview': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdOverviewImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/events/event/$id/payments': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdPaymentsImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/leads/lead/$id/calls': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdCallsImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/leads/lead/$id/cci': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdCciImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/leads/lead/$id/changes': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdChangesImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/leads/lead/$id/customer': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdCustomerImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/leads/lead/$id/messages': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdMessagesImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/leads/lead/$id/pricing': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdPricingImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/leads/lead/$id/quote': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdQuoteImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/leads/lead/$id/review': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdReviewImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/customers/customer/$id/changes': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdChangesLazyImport
      parentRoute: typeof AuthenticatedCustomersCustomerIdImport
    }
    '/_authenticated/customers/customer/$id/edit': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdEditLazyImport
      parentRoute: typeof AuthenticatedCustomersCustomerIdImport
    }
    '/_authenticated/customers/customer/$id/events': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdEventsLazyImport
      parentRoute: typeof AuthenticatedCustomersCustomerIdImport
    }
    '/_authenticated/customers/customer/$id/leads': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdLeadsLazyImport
      parentRoute: typeof AuthenticatedCustomersCustomerIdImport
    }
    '/_authenticated/customers/customer/$id/messages': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdMessagesLazyImport
      parentRoute: typeof AuthenticatedCustomersCustomerIdImport
    }
    '/_authenticated/customers/customer/$id/payments': {
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdPaymentsLazyImport
      parentRoute: typeof AuthenticatedCustomersCustomerIdImport
    }
    '/_authenticated/equipment/maintenance/inspections/$id': {
      preLoaderRoute: typeof AuthenticatedEquipmentMaintenanceInspectionsIdLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/maintenance/inspections/new': {
      preLoaderRoute: typeof AuthenticatedEquipmentMaintenanceInspectionsNewLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/maintenance/schedules/$id': {
      preLoaderRoute: typeof AuthenticatedEquipmentMaintenanceSchedulesIdLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/equipment/maintenance/schedules/new': {
      preLoaderRoute: typeof AuthenticatedEquipmentMaintenanceSchedulesNewLazyImport
      parentRoute: typeof AuthenticatedEquipmentRouteLazyImport
    }
    '/_authenticated/events/event/$id/accept-transfer': {
      preLoaderRoute: typeof AuthenticatedEventsEventIdAcceptTransferLazyImport
      parentRoute: typeof AuthenticatedEventsEventIdImport
    }
    '/_authenticated/leads/lead/$id/accept-transfer': {
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdAcceptTransferLazyImport
      parentRoute: typeof AuthenticatedLeadsLeadIdLazyImport
    }
    '/_authenticated/products/addons/$product_id/$id': {
      preLoaderRoute: typeof AuthenticatedProductsAddonsProductidIdLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_authenticated/products/addons/$product_id/new': {
      preLoaderRoute: typeof AuthenticatedProductsAddonsProductidNewLazyImport
      parentRoute: typeof AuthenticatedProductsRouteLazyImport
    }
    '/_frameless/fs/equipment/inspections/$inspection_id/inspection-logs/$id': {
      preLoaderRoute: typeof FramelessFsEquipmentInspectionsInspectionidInspectionLogsIdImport
      parentRoute: typeof FramelessImport
    }
    '/_frameless/fs/equipment/inspections/$inspection_id/inspection-logs/new': {
      preLoaderRoute: typeof FramelessFsEquipmentInspectionsInspectionidInspectionLogsNewImport
      parentRoute: typeof FramelessImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AuthenticatedRoute.addChildren([
    AuthenticatedCalendarRouteRoute,
    AuthenticatedSchedulerRouteRoute,
    AuthenticatedDashboardRoute,
    AuthenticatedAccountRouteLazyRoute.addChildren([
      AuthenticatedAccountInstagramAuthorizationLazyRoute,
      AuthenticatedAccountStripeAuthorizationLazyRoute,
      AuthenticatedAccountUserProfileLazyRoute,
      AuthenticatedAccountVirtualBusinessCardLazyRoute,
    ]),
    AuthenticatedEquipmentRouteLazyRoute.addChildren([
      AuthenticatedEquipmentAssetsIdLazyRoute,
      AuthenticatedEquipmentAssetsNewLazyRoute,
      AuthenticatedEquipmentDepotsIdLazyRoute,
      AuthenticatedEquipmentDepotsNewLazyRoute,
      AuthenticatedEquipmentGeneratorsIdLazyRoute,
      AuthenticatedEquipmentUnitsIdLazyRoute,
      AuthenticatedEquipmentVehiclesIdLazyRoute,
      AuthenticatedEquipmentVehiclesNewLazyRoute,
      AuthenticatedEquipmentWorkOrdersIdLazyRoute,
      AuthenticatedEquipmentWorkOrdersNewLazyRoute,
      AuthenticatedEquipmentAssetsIndexLazyRoute,
      AuthenticatedEquipmentCalendarIndexLazyRoute,
      AuthenticatedEquipmentDashboardIndexLazyRoute,
      AuthenticatedEquipmentDepotsIndexLazyRoute,
      AuthenticatedEquipmentGeneratorsIndexLazyRoute,
      AuthenticatedEquipmentVehiclesIndexLazyRoute,
      AuthenticatedEquipmentWorkOrdersIndexLazyRoute,
      AuthenticatedEquipmentMaintenanceInspectionsIdLazyRoute,
      AuthenticatedEquipmentMaintenanceInspectionsNewLazyRoute,
      AuthenticatedEquipmentMaintenanceSchedulesIdLazyRoute,
      AuthenticatedEquipmentMaintenanceSchedulesNewLazyRoute,
    ]),
    AuthenticatedProductsRouteLazyRoute.addChildren([
      AuthenticatedProductsCouponsIdLazyRoute,
      AuthenticatedProductsCouponsNewLazyRoute,
      AuthenticatedProductsPackagesIdLazyRoute,
      AuthenticatedProductsPackagesNewLazyRoute,
      AuthenticatedProductsServicesIdLazyRoute,
      AuthenticatedProductsServicesNewLazyRoute,
      AuthenticatedProductsAddonsIndexLazyRoute,
      AuthenticatedProductsCouponsIndexLazyRoute,
      AuthenticatedProductsPackagesIndexLazyRoute,
      AuthenticatedProductsServicesIndexLazyRoute,
      AuthenticatedProductsAddonsProductidIdLazyRoute,
      AuthenticatedProductsAddonsProductidNewLazyRoute,
    ]),
    AuthenticatedReportsRouteLazyRoute.addChildren([
      AuthenticatedReportsDashboardLazyRoute,
      AuthenticatedReportsLocationScorecardLazyRoute,
      AuthenticatedReportsSystemScorecardLazyRoute,
      AuthenticatedReportsCallcenterCloseRateLazyRoute,
      AuthenticatedReportsCallcenterConversationsLazyRoute,
      AuthenticatedReportsCallcenterMissedLeadsLazyRoute,
      AuthenticatedReportsCallcenterSpeedToLeadLazyRoute,
      AuthenticatedReportsFinanceCashLazyRoute,
      AuthenticatedReportsMarketingLeadsLazyRoute,
      AuthenticatedReportsMarketingOverviewLazyRoute,
      AuthenticatedReportsOpsNpsLazyRoute,
      AuthenticatedReportsRevenueActivityTypeLazyRoute,
      AuthenticatedReportsRevenueCollectedPaymentsLazyRoute,
      AuthenticatedReportsRevenueEventTypeLazyRoute,
      AuthenticatedReportsRevenueOverviewLazyRoute,
      AuthenticatedReportsRevenueSalesTaxLazyRoute,
      AuthenticatedReportsSalesActivityTypeLazyRoute,
      AuthenticatedReportsSalesDetailLazyRoute,
      AuthenticatedReportsSalesEventTypeLazyRoute,
      AuthenticatedReportsSalesOverviewLazyRoute,
      AuthenticatedReportsSalesSalesTeamLazyRoute,
    ]),
    AuthenticatedResourcesRouteLazyRoute.addChildren([
      AuthenticatedResourcesDirectoryLazyRoute,
      AuthenticatedResourcesStoreLazyRoute,
      AuthenticatedResourcesStripeLazyRoute,
    ]),
    AuthenticatedSettingsRouteLazyRoute.addChildren([
      AuthenticatedSettingsAccessLazyRoute,
      AuthenticatedSettingsAccountingLazyRoute,
      AuthenticatedSettingsAdvancedLazyRoute,
      AuthenticatedSettingsBusinessLazyRoute,
      AuthenticatedSettingsFaqsLazyRoute,
      AuthenticatedSettingsGeneralLazyRoute,
      AuthenticatedSettingsNotificationsLazyRoute,
      AuthenticatedSettingsPoliciesLazyRoute,
      AuthenticatedSettingsPowerupsLazyRoute,
      AuthenticatedSettingsSalesTeamLazyRoute,
      AuthenticatedSettingsSocialMediaLazyRoute,
      AuthenticatedSettingsReferralCampaignCodeLazyRoute,
      AuthenticatedSettingsReferralCampaignIndexLazyRoute,
    ]),
    AuthenticatedHelpLazyRoute,
    AuthenticatedCustomersFilterRouteRoute.addChildren([
      AuthenticatedCustomersFilterIndexRoute,
    ]),
    AuthenticatedEventsFilterRouteRoute.addChildren([
      AuthenticatedEventsFilterIndexRoute,
    ]),
    AuthenticatedLeadsFilterRouteRoute.addChildren([
      AuthenticatedLeadsFilterIndexRoute,
    ]),
    AuthenticatedCustomersRewardsRouteLazyRoute,
    AuthenticatedCallcenterPoolReportLazyRoute,
    AuthenticatedCallcenterTeamLazyRoute,
    AuthenticatedLeaderboardTabLazyRoute,
    AuthenticatedMapTabLazyRoute,
    AuthenticatedConversationsIndexLazyRoute,
    AuthenticatedCustomersCustomerIdRoute.addChildren([
      AuthenticatedCustomersCustomerIdCallsRoute,
      AuthenticatedCustomersCustomerIdOverviewRoute,
      AuthenticatedCustomersCustomerIdChangesLazyRoute,
      AuthenticatedCustomersCustomerIdEditLazyRoute,
      AuthenticatedCustomersCustomerIdEventsLazyRoute,
      AuthenticatedCustomersCustomerIdLeadsLazyRoute,
      AuthenticatedCustomersCustomerIdMessagesLazyRoute,
      AuthenticatedCustomersCustomerIdPaymentsLazyRoute,
    ]),
    AuthenticatedEventsEventIdRoute.addChildren([
      AuthenticatedEventsEventIdCallsRoute,
      AuthenticatedEventsEventIdCciRoute,
      AuthenticatedEventsEventIdChangesRoute,
      AuthenticatedEventsEventIdCustomerRoute,
      AuthenticatedEventsEventIdEditRoute,
      AuthenticatedEventsEventIdEsignRoute,
      AuthenticatedEventsEventIdInvoiceRoute,
      AuthenticatedEventsEventIdMessagesRoute,
      AuthenticatedEventsEventIdOverviewRoute,
      AuthenticatedEventsEventIdPaymentsRoute,
      AuthenticatedEventsEventIdAcceptTransferLazyRoute,
    ]),
    AuthenticatedEventsToolsEventPacksRoute,
    AuthenticatedEventsToolsGapFinderRoute,
    AuthenticatedCustomersListsIdLazyRoute,
    AuthenticatedCustomersListsNewLazyRoute,
    AuthenticatedLeadsLeadIdLazyRoute.addChildren([
      AuthenticatedLeadsLeadIdCallsRoute,
      AuthenticatedLeadsLeadIdCciRoute,
      AuthenticatedLeadsLeadIdChangesRoute,
      AuthenticatedLeadsLeadIdCustomerRoute,
      AuthenticatedLeadsLeadIdMessagesRoute,
      AuthenticatedLeadsLeadIdPricingRoute,
      AuthenticatedLeadsLeadIdQuoteRoute,
      AuthenticatedLeadsLeadIdReviewRoute,
      AuthenticatedLeadsLeadIdAcceptTransferLazyRoute,
    ]),
    AuthenticatedCustomersListsIndexLazyRoute,
  ]),
  FramelessRoute.addChildren([
    FramelessFsEquipmentInspectionsInspectionidInspectionLogsIdRoute,
    FramelessFsEquipmentInspectionsInspectionidInspectionLogsNewRoute,
  ]),
  PublicRoute.addChildren([
    PublicLoginRoute,
    PublicPasswordForgotLazyRoute,
    PublicPasswordResetTokenLazyRoute,
  ]),
])

/* prettier-ignore-end */
